import React, { Component } from 'react';
import {
  View,
  Dimensions,
  Text,
  TextInput,
  Image,
  TouchableOpacity,
  Vibration,
  Platform,
  ScrollView,
  FlatList
} from 'react-native';
import * as Clipboard from 'expo-clipboard';
import styles from '../../style/scanpack';
import commonStyles from '../../style/commonStyles';
import globalStyles from '../../style/global';
import moment from 'moment';
import HTML from 'react-native-render-html';
import upArrow from '../../../assets/up_arrow.png';
import downArrow from '../../../assets/down_arrow.png';
import note from '../../../assets/note.png';
import placeholder from '../../../assets/placeholder.jpg';
import { LinearGradient } from 'expo-linear-gradient';
import { fontFamily } from '../../helpers/fontFamily';
import { connect } from 'react-redux';
import Input from '../../commons/Inputs/input';
import DisplayImage from './displaySuggestedImage';
import i18n from 'i18n-js';
import { getIconType } from 'react-native-elements';
import OrderItem from '../../commons/orderItem';
import OrderItemImage from '../../commons/orderItemImage';
import OrderKitItem from '../../commons/orderKitItem';
import ActionBarButtons from './actionBarButtons';
import DisplayOrderNumber from '../../commons/displayOrderNumber';
import OrderItemListMenu from '../../commons/orderItmesListMenu';
import DisplayInstructions from '../../commons/displayOrderInstructions';
import DisplayLogs from '../../commons/displayLogs';
import OrderItemSuggested from '../../commons/orderItemSuggested';
import BoxChampBoxImage from './BoxChampBoxImage';
import {sortUnscannedItems} from './boxChampSort';
import BoxChampZonedList from './BoxChampZonedList';
import {createGuidedViewMemo, createLiveTreeMemo} from './boxChampGuided';
import BoxChampReopenPrompt from './BoxChampReopenPrompt';
import {reopenTarget} from './boxChampReopen';
import { AddBox, GetOrderDetail, RemoveBoxItems,PrintSlip } from '../../actions/orderActions';
import { updateScanScore } from '../../actions/scanScoreAction';
import ScanButtonContainer from './scanButtonContainer';
import ScannedKitItem from '../../commons/scannedKitItem';
import ScannedKitItemContainer from '../../commons/ScannedKitItemContainer';
import SuggestedMenuMobile from './suggestedMenuMobile';
import DisplayDashboardData from '../../commons/displayLiveStats';
import ScoringGame from '../scoringGame/index';
import { formatSpeechMessage, TTS_VERBOSITY, SPEAK_ONLY_ON_ITEM_CHANGE, initializeVoices } from '../../helpers/textToSpeech';
import NotFulfilledItems from './NotFulfilledItems';
import { checkIfAllFromNotFulfilled, getUnscannedItemsTitle } from './scanBarcodeFunctions';
import { Ionicons } from '@expo/vector-icons';
import CamScanner from '../camScanning/CamScanner';

let inputValue = '';
let isPassButtonPressed =  false
let isRemoveCalled = false;
// import ScanBarCodeInput from '../../commons/Inputs/scanBarcodeInput';
class NextItemMobileView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        filter: 'awaiting',
        order: 'DESC',
        limit: '1',
        offset: '0'
      },
      showMenu: false,
      score: 0,
      multiplier: 1,
      accumulatorProgress: 0,
      boxChampSortMode: 'location',
      boxChampReopenBox: null,
      boxChampPendingRemoval: null
    }
    this._isMounted = false;
    this.getGuidedView = createGuidedViewMemo();
    this.getLiveTree = createLiveTreeMemo();
  }

  renderGuidedCard = (item, index) => (
    <View testID={`boxchamp-unscanned-item-${item?.order_item_id}`}>
      {(item && item.product_type === 'single') ||
      (item && item.product_type === 'depends') ? (
        <View style={styles.scanPackSingleItemContainer}>
          <OrderItem
            item={item}
            redirectToItemDetail={it => {
              this.props.redirectToItemDetail(it);
            }}
            testID={'ProductName' + index}
          />
          <OrderItemImage
            item={item}
            testID={'shuffleItem'}
            listType={'unscanned'}
            shuffleTheItem={sku => {
              this.props.shuffleTheItem(sku);
            }}
          />
        </View>
      ) : (
        <OrderKitItem
          item={item}
          index={index}
          windowWidth={this.props.windowWidth}
          redirectToItemDetail={it => {
            this.props.redirectToItemDetail(it);
          }}
          shuffleTheItem={sku => {
            this.props.shuffleTheItem(sku);
          }}
          shuffleTheKitItem={(kitSku, itemSku) => {
            this.props.shuffleTheItem(kitSku, itemSku);
          }}
          listType={'unscanned'}
        />
      )}
    </View>
  );

  toggleBoxChampSort = () => {
    const mode = this.state.boxChampSortMode === 'packing' ? 'location' : 'packing';
    this.setState({boxChampSortMode: mode});
    if (this.props.SaveBoxChampSortPreference) this.props.SaveBoxChampSortPreference(mode);
  };

  getSortedUnscanned = Order => {
    const items = Order && Order.unscanned_items;
    const placement = this.props.Order || Order;
    const mode = this.state.boxChampSortMode;
    const boxes = placement && placement.boxes;
    const oib = placement && placement.order_item_boxes;
    const c = this._sortMemo;
    if (c && c.items === items && c.mode === mode && c.boxes === boxes && c.oib === oib) {
      return c.result;
    }
    const result = sortUnscannedItems(items, mode, boxes, oib);
    this._sortMemo = {items, mode, boxes, oib, result};
    return result;
  };
  // keyDownHandler = event => {
  //   if (event.key === 'Enter' && event.target.name === 'scanBarCodeInput') {
  //     if (this.props.barcodeState === '' || this.props.barcodeState === '*') {
  //       this.props.scanBarcode();
  //     }
  //   }
  // };
  getTop = () => {
    const bannerOffset = this.props.boxChampBannerHeight || 0;
    if (Platform.OS === 'ios' || window.navigator.platform === 'iPhone' && window.navigator.standalone) {
      return 85 + bannerOffset
    }
    return 40 + bannerOffset
  }

  componentDidMount() {
    this._isMounted = true;
    initializeVoices();
    if (this.props.GetBoxChampSortPreference) {
      this.props.GetBoxChampSortPreference().then(mode => {
        if (mode && this._isMounted) this.setState({boxChampSortMode: mode});
      });
    }

    if (window.navigator.platform === 'iPhone' || Platform.OS === 'ios') {
      document.addEventListener('keydown', this.keyDownHandler, false);
    }
  }
  componentDidUpdate() {
    if (this.props.removeOrderItems && isRemoveCalled) {
      isRemoveCalled = false;
      this.props.getOrderData(this.props?.order?.order?.increment_id);
      this.props.getUpdateSettings();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    document.removeEventListener('keydown', this.keyDownHandler);
    let props = this?.props
    let unscannedCount = props?.order?.order?.unscanned_items;
    const boxChampPlanned = (props?.Order?.boxes || []).some(
      b => b && b.source === 'box_champ'
    );
    if(unscannedCount?.length === 0 && !boxChampPlanned){
      this.addBox()
    }
    let multiboxSetting = props?.bothSettings?.data?.data?.general_setting;
    if(
      unscannedCount.length == 0 &&
      multiboxSetting?.per_box_packing_slips === 'when_order_is_complete' &&
      multiboxSetting?.multi_box_shipments
    ) {
      this.orderCompletePrintSlip();
      return false;
    }
  }
  orderCompletePrintSlip = () => {
    let arrayempty = [];
    let Order =  this?.props?.Order
    Order?.boxes?.map((item, index) => {
      arrayempty.push(item.id);
    });
    let item = {
      box_ids: arrayempty,
      orderArray: [{id: Order?.basicinfo?.id}]
    };
    this.props.PrintSlip(item);
  };

  openCameraScanner = () => {
    if (this.props.openCameraScanner) {
      this.props.openCameraScanner();
    }
  };

  copyOrderNumberToClipboard = async () => {
    await Clipboard.setStringAsync(`${this.props.order.order.increment_id}`);
  };
  addBox = () => {
    let multi_box_shipments =  this.props?.bothSettings?.data?.data?.general_setting?.multi_box_shipments
    let OrderCommon = this.props?.Order
    let boxItemProps = this.props?.Order?.order_item_boxes
    let addBoxAfterPrint = this.props?.bothSettings?.data?.data?.general_setting?.per_box_packing_slips
    let boxProps = OrderCommon?.boxes
    let boxFilter = boxItemProps?.filter((i) => i.box_id == boxProps[boxProps.length - 1]?.id)
    let item = {
      name: `Box ${this?.props?.Order?.boxes?.length + 1}`,
      order_id: OrderCommon?.basicinfo?.id
    };
    if(boxItemProps !== undefined && boxItemProps[boxProps?.length - 1] && boxFilter?.length && !this.props.popInternet){
      let boxObject = boxProps[boxProps.length -1]
      boxProps.push({name : item.name, id :typeof boxObject.id !== 'number' ? `unique ${boxObject?.id.split('-')[1]+1 }`: boxProps[boxProps.length -1]?.id + 1})
      this.props.goNext()
    }else if(!this.props.popInternet && multi_box_shipments ){
        this.props.multiBoxStateUpdate()
    }
    if (boxItemProps !== undefined && boxItemProps[boxProps?.length - 1] && boxFilter.length > 0) {
      this.props.AddBox(item, this.props.goNext, this.props?.Order?.boxes);
      if (addBoxAfterPrint === 'when_new_boxes_are_started') {
        this.props.printSlipFun();
      }
    } else {
      if(this.props.popInternet && multi_box_shipments) this.props.multiBoxStateUpdate();
    }
  }

  removeBoxItem = async (box_id, order_item_id, kit_product_id) => {
    const Order = this.props?.order?.order;
    const sealed = reopenTarget({
      view: this.getGuidedView(
        this.getLiveTree(Order, this.props.notFullFilledItems),
        [this.props.Order, Order]
      ),
      orderItemId: order_item_id,
      kitId: kit_product_id ?? null,
      preferredBoxId: box_id ?? null,
      sealConfirmedBoxIds: this.props.boxChampSealConfirmedBoxIds
    });
    if (sealed && !this.state.boxChampPendingRemoval) {
      this.setState({
        boxChampReopenBox: sealed,
        boxChampPendingRemoval: {box_id, order_item_id, kit_product_id}
      });
      return;
    }
    this.setState({boxChampReopenBox: null, boxChampPendingRemoval: null});
    this.performRemoveBoxItem(box_id, order_item_id, kit_product_id);
  }

  confirmBoxChampReopen = () => {
    const pending = this.state.boxChampPendingRemoval;
    this.setState({boxChampReopenBox: null, boxChampPendingRemoval: null}, () => {
      if (pending) {
        this.performRemoveBoxItem(pending.box_id, pending.order_item_id, pending.kit_product_id);
      }
    });
  };

  cancelBoxChampReopen = () =>
    this.setState({boxChampReopenBox: null, boxChampPendingRemoval: null});

  performRemoveBoxItem = (box_id, order_item_id, kit_product_id) => {
    const id = this.props?.Order?.basicinfo?.id
    let data = {
      box_id,
      kit_product_id,
      order_item_id,
      id,
    };
    this.props?.RemoveBoxItems(data)
    setTimeout(() => { this.props.updateOrder(this?.props?.order?.order?.increment_id) }, 300)
  }

  orderDetailFun = id => {
    let detail = {
      id: id,
      orderDetail: this.state.data
    };
    if (id !== null) {
      this.props.GetOrderDetail(detail);
    }
  };

  checky = (boxId) => {
    if (boxId) {
      return this.props?.Order.order_item_boxes.filter((data) => data.box_id === boxId).map((data) => data.item_qty).reduce((a, b) => a + b, 0)
    }
    return 0
  }

  // Helper method to calculate scanned count from a specific order
  calculateScannedCount = (order) => {
    let localCount = 0;
    if (order && order.scanned_items && order.scanned_items.length > 0) {
      order.scanned_items.forEach(item => {
        if (item?.child_items?.length === 0 || item?.child_items === undefined) {
          localCount = localCount + item.scanned_qty;
        }
      });
    }
    return localCount;
  }

  handlePassButton = (item) =>{
    if(inputValue !== ''){
      this.props.stateUpdate(inputValue)
      this.props.scanBarcode()
      inputValue = ''
      isPassButtonPressed = !isPassButtonPressed
      return
    }
    const currentProductId = this.props.order?.order?.unscanned_items?.[0]?.product_id;
    this.props.clickScan(item)
    setTimeout(() => {
      const newProductId = this.props.order?.order?.unscanned_items?.[0]?.product_id;
      const isNewProduct = currentProductId !== newProductId;
      const event = new CustomEvent('suggestedItemChanged', { 
        detail: { isItemChange: isNewProduct } 
      });

      window.dispatchEvent(event);
    }, 500);
  }

  render() {
    const scannedItems = this.props?.order?.order?.scanned_items
    const multi_box_shipments = this.props?.bothSettings?.data?.data?.general_setting?.multi_box_shipments;
    let Order = this.props.order.order;
    const guidedView = this.getGuidedView(
      this.getLiveTree(Order, this.props.notFullFilledItems),
      [this.props.Order, Order]
    );
    let slider_image = [];
    let localLogs = this.props.localLogs;
    // const rows = this.props.getAttributeRows()
    const windowHeight = Dimensions.get('window').height;
    return (
      <>
        <BoxChampReopenPrompt
          box={this.state.boxChampReopenBox}
          onConfirm={this.confirmBoxChampReopen}
          onCancel={this.cancelBoxChampReopen}
        />
        {this.state.showMenu &&
          <SuggestedMenuMobile
            {...this.props}
            getWidth={this.props.getWidth}
            getMargin={this.props.getMargin}
            updateShowMenu={() =>  {
              this.setState({ showMenu: false })}
            }
            updateIsRemove={() =>  {
              isRemoveCalled = true
            }}
          />
        }
        {Order?.unscanned_items[0] ? (
          <View
            style={[
              globalStyles.flex1,
              {
                width: '100%',
                height: '100%',
                zIndex: -1,
                top: this.getTop(),
                position: 'fixed'
              }
            ]}>
            <ScrollView
              keyboardShouldPersistTaps="handled"
              scrollEventThrottle={10}
              style={{ height: '100%' }}>
              <View style={styles.nextItemsMain}>
                {this.props.order && Order.unscanned_items[0] && (
                  <View style={styles.RFPScreen}>
                    <View
                      style={globalStyles.nextItemFlex}>
                      <View style={styles.actionButtonsView}>
                        <DisplayOrderNumber
                         orderDetail={() =>this.props.orderDetail(Order)}
                         incrementId={Order.increment_id}
                         actionBarShow={this.props.actionBarShow}
                         setActionBarState={() => {
                          let actionBarShow = !this.props.actionBarShow;
                          this.props.actionBarShowFunMobile(actionBarShow);
                         }}
                         downArrow={downArrow}
                         upArrow={upArrow}
                         copyOrderNumberToClipboard={this.copyOrderNumberToClipboard}
                         id={'orderDetail'}
                        />
                        {this.props.actionBarShow && (

                          <ActionBarButtons
                           width={this.props.windowWidth}
                           onPressRestartOrder={()=>{
                            this.props.popInternet === true && (
                                this.props.restartButton()
                              )
                            }}
                            restartButtonDesign={styles.restartButtonDesign}
                            onPressGetOrderData={() => {
                              this.props.getOrderData(Order.increment_id);
                              this.props.getUpdateSettings();
                              }}
                            reloadButtonDesign={styles.noteSaveButtonDesign}
                            onPressAddNote={()=>{
                              this.props.popInternet === true && (
                                  this.props.addNote()
                                )
                            }}
                          />
                        )}
                      </View>
                      <LinearGradient
                        style={globalStyles.nextItemMobile}
                        start={{ x: 0, y: 1 }}
                        end={{ x: 0, y: 0 }}
                        colors={['#142130', '#304454']}>
                        <View style={{ flexDirection: 'row' }}>
                          <View
                            style={globalStyles.nextItemMobileFlex}>
                            <LinearGradient
                              start={{ x: 0, y: 1 }}
                              end={{ x: 0, y: 0 }}
                              colors={['#6384ff', '#1329ff', '#35096c']}
                              style={globalStyles.serialRecord}
                            />
                          </View>
                          {!this.props.serialRecordPopUpShow && (
                            <Input
                              testID="boxchamp-box-barcode-input"
                              dataSet={{ componentName: 'scanBarCodeInput' }}
                              name="scanBarCodeInput"
                              value={this.props.barcodeState}
                              isClicked ={this.props.isClicked}
                              isPassButtonPressed = { isPassButtonPressed}
                              autoFocus={false}
                              suppressSoftwareKeyboard={true}
                              ref={this.props.InputField}
                              onSubmitEditing={()=>{
                                this.props.popInternet === true && (
                                  this.props.scanBarcode())
                                }
                              }
                              onChangeText={this.props.stateUpdate}
                              onChangeValue={(text)=>{inputValue = text}}
                              style={[globalStyles.scanBarCodeInput, { paddingRight: 48, minWidth: 0, flexShrink: 1 }]}
                              placeholder={this.props.scanPlaceHolderValue}
                              placeholderTextColor={'#acacad'}
                              // setIsBarcodeEnter = {() => { this.setState({ isBarcodeEnter: true }); }}
                              onBlur={() => {
                                const blurValue =
                                  Platform.OS === 'web'
                                    ? i18n.t("nextItems.clickScanLabel")
                                    : i18n.t("nextItems.tabHereLabel");
                                this.props.scanPlaceHolderValueFunMobile(
                                  blurValue
                                );
                                // this.setState({ scanPlaceHolderValue: blurValue })
                              }}
                              onFocus={() =>
                                this.props.scanPlaceHolderValueFunMobile(
                                  i18n.t("nextItems.readyForScanLabel")
                                )
                              }
                            // onFocus={() => this.setState({ scanPlaceHolderValue: 'Ready For Product Scan' })}
                            />
                          )}

                          {!this.props.serialRecordPopUpShow && this.props.camScannerEnabled && (
                            <TouchableOpacity
                              testID="cameraScanBtn"
                              style={{
                                position: 'absolute',
                                right: 100,
                                top: '50%',
                                transform: [{ translateY: -12 }],
                                zIndex: 10,
                              }}
                              onPress={this.openCameraScanner}>
                              <Ionicons
                                name="camera"
                                size={24}
                                color="#acacad"
                              />
                            </TouchableOpacity>
                          )}
                          <ScanButtonContainer
                            Order={Order}
                            popInternet={this.props.popInternet}
                            scanAllItem={this.props.scanAllItem}
                            windowWidth={this.props.windowWidth}
                            setType={this.props.setType}
                            checkCount={this.props.checkCount}
                            scanAllOption={this.props.scanPackSetting.scan_all_option}
                            typeScanState={this.props.typeScanState}
                            handlePassButton = {this.handlePassButton}
                            isBarcodeEnter = {this.props.isBarcodeEnter}
                            setIsBarcodeEnter = {this.props.setIsBarcodeEnter}
                          />
                        </View>
                      </LinearGradient>
                      {(Order.tags !== null &&
                        Order.tags.trim() !== '' &&
                        this.props.settings.show_tags &&
                        this.props.tagsToPackerFlag) ||
                        (Order.notes_toPacker !== null &&
                          Order.notes_toPacker &&
                          Order.notes_toPacker.trim() !== '' &&
                          this.props.notesToPackerFlag &&
                          this.props.settings.show_internal_notes) ||
                        (Order.customer_comments !== null &&
                          Order.customer_comments &&
                          Order.customer_comments.trim() !== '' &&
                          this.props.customerCommentsFlag &&
                          this.props.settings.show_customer_notes) ||
                        (Order.notes_internal !== null &&
                          Order.notes_internal &&
                          Order.notes_internal.trim() !== '' &&
                          this.props.internalNotesFlag &&
                          this.props.settings.show_internal_notes) ? (
                        <LinearGradient
                          locations={[0, 0.13, 1]}
                          colors={['#000000', '#fdf359', '#d2c609']}
                          style={globalStyles.nextItemNotes}
                        >
                          <View style={{ width: '100%' }}>
                            {Order.tags !== null && Order.tags.trim() !== '' && (
                              <View>
                                <Text
                                  style={commonStyles.nextItemText}
                                >
                                  {Order.tags}
                                </Text>
                                {((Order.customer_comments !== null &&
                                  Order.customer_comments.trim() !== '') ||
                                  (Order.notes_toPacker !== null &&
                                    Order.notes_toPacker.trim() !== '') ||
                                  (Order.notes_internal !== null &&
                                    Order.notes_internal &&
                                    Order.notes_internal.trim() !== '')) && (
                                    <View
                                      style={commonStyles.nextItemNotes}
                                    />
                                  )}
                              </View>
                            )}
                            {Order.notes_internal &&
                              Order.notes_internal !== null &&
                              Order.notes_internal.trim() !== '' && (
                                <View>
                                  {Order.notes_internal !== null && (
                                    <Text
                                      style={commonStyles.nextItemText}
                                    >
                                      {Order.notes_internal}
                                    </Text>
                                  )}
                                  {((Order.customer_comments !== null &&
                                    Order.customer_comments.trim() !== '') ||
                                    (Order.notes_toPacker !== null &&
                                      Order.notes_toPacker.trim() !== '')) && (
                                      <View
                                        style={commonStyles.nextItemNotes}
                                      />
                                    )}
                                </View>
                              )}
                            {Order.customer_comments !== null &&
                              Order.customer_comments.trim() !== '' && (
                                <View>
                                  <Text
                                    style={commonStyles.nextItemText}
                                  >
                                    {Order.customer_comments}
                                  </Text>
                                  {(Order.notes_toPacker !== null
                                    ? Order.notes_toPacker.trim() !== ''
                                    : false) && (
                                      <View
                                        style={commonStyles.nextItemNotes}
                                      />
                                    )}
                                </View>
                              )}
                            {Order.notes_toPacker !== null &&
                              Order.notes_toPacker.trim() !== '' && (
                                <Text
                                  style={commonStyles.nextItemText}
                                >
                                  {Order.notes_toPacker}
                                </Text>
                              )}
                            <View>
                              <TouchableOpacity
                                onPress={() => this.props.closeNotes()}
                                style={commonStyles.nextItemCloseNote}>
                                <Text
                                  style={[commonStyles.nextItemText, { lineHeight: '100%' }]}
                                >
                                  {i18n.t('nextItems.gotItLabel')}
                                </Text>
                              </TouchableOpacity>
                            </View>
                          </View>
                        </LinearGradient>
                      ) : null}
                      {Order.unscanned_items[0].product_type === 'individual' &&
                        Order.unscanned_items[0].child_items.length > 0 ? (
                        <React.Fragment>
                          {Order.unscanned_items[0].child_items[0]
                            .instruction !== '' &&
                            Order.unscanned_items[0].child_items[0]
                              .instruction !== null && (
                              <DisplayInstructions
                               item={Order.unscanned_items[0].child_items[0]}
                               width={this.props.windowWidth}
                              />
                            )}
                          {this.props.isRealTimeStatEnabled && <DisplayDashboardData /> }
                          {/* Scoring Game Component */}
                          <View style={{ 
                            backgroundColor: '#121212', 
                            padding: 10,
                            borderRadius: 4,
                            marginHorizontal: 10,
                            marginVertical: 5
                          }}>
                            {this.props?.scanToScoreEnabled && <ScoringGame
                              scannedCount={this.calculateScannedCount(this.props.order.order)}
                              onScoreUpdate={(scoreData) => {
                                if (this.state.score !== scoreData.score) {
                                  this.setState({
                                    score: scoreData.score,
                                    multiplier: scoreData.multiplier,
                                    accumulatorProgress: scoreData.accumulatorProgress
                                  });
                                  this.props.updateScanScore({score: scoreData.score});
                                }
                              }}
                              soundsEnabled={true}
                            /> }
                          </View>
                          
                          <BoxChampBoxImage
                            boxes={this.props?.Order?.boxes}
                            activeBoxIndex={this.props.activeBoxIndex}
                            activeBoxId={guidedView?.projection?.activeBoxId ?? null}
                            verifiedBoxIds={this.props.verifiedBoxIds}
                            boxChampEnabled={
                              this.props?.bothSettings?.data?.data?.general_setting?.is_box_champ
                            }
                          />
                          <View
                            style={commonStyles.nextItemRowFlexMobile}
                          >
                            <OrderItemSuggested
                             redirectToItemDetail={(item)=>{this.props.redirectToItemDetail(item)}}
                             item={Order.unscanned_items[0].child_items[0]}
                             isSwap={this.props.isSwap}
                             displayRow={!this.props.isSwap &&
                                this.props.rowsChild.map(row => row)}
                             displayRowAtTop = {this.props.isSwap &&
                                this.props.rowsChild.map(row => row)}
                             numberOfKeysEven={this.props.numberOfKeysEven}
                             testID={'redirectToItem'}
                             getFontSize={this.props.getFontSize}
                             addBarcodeFun={(item)=>{this.props.addBarcode(item)}}
                             width={this.props.windowWidth}
                            />
                            <DisplayImage
                              webBigImage={this.props.webBigImage}
                              onError={err => this.props.imageCheck(err)}
                              source={placeholder}
                              defaultSource={placeholder}
                              scanned_qty={
                                Order.unscanned_items[0].child_items[0]
                                  .scanned_qty
                              }
                              total_qty={
                                Order.unscanned_items[0].child_items[0]
                                  .qty_remaining +
                                Order.unscanned_items[0].child_items[0]
                                  .scanned_qty
                              }
                              images={
                                Order.unscanned_items[0].child_items[0].images
                              }
                              updateShowMenu={() =>  {
                                this.setState({ showMenu: true })}}
                            />
                          </View>
                          {this.props.showCameraScanner && (
                            <View style={{ padding: 10 }}>
                              <CamScanner
                                inline={true}
                                bottomControls={true}
                                onScan={this.props.handleCameraScan}
                                onClose={this.props.handleCameraClose}
                              />
                            </View>
                          )}
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          {
                            this.props.checkMultiOrderPresent && this.props.checkMultiOrderPresent?.length > 1 ? (
                              <View style={{ padding: "10px" }}>
                                <View style={[styles.sameOrderAlertTopView]}>
                                  {
                                    this.props.checkShippingEasyOrder === true ?
                                      <Text style={[styles.alertBoxOutsideTextMobile]}>{i18n.t('scanpackItem.shippingEsaySameOrderTextAlert')} </Text> :
                                      <Text style={[styles.alertBoxOutsideTextMobile]}>{i18n.t('scanpackItem.shipStationSameOrderText')} </Text>}
                                </View>
                                {
                                  this.props.checkMultiOrderPresent?.map((i) =>
                                    <>
                                      {
                                        this.props.searchOrder?.searchOrder?.data?.order[0]?.id != i.id ?
                                          <TouchableOpacity
                                            testID='redirecToSameOrder'
                                            onPress={() => this.props.redirecToSameOrder(i.increment_id, i.store_order_id)}>
                                            <LinearGradient
                                              start={{ x: 0, y: 1 }}
                                              end={{ x: 0, y: 0 }}
                                              colors={['#142130', '#304454']}
                                              style={[styles.sameOrderAlertLinear]}>
                                              <i
                                                className="icon-attention"
                                                style={{
                                                  color: 'orange', fontSize: '36px', position: 'static',
                                                }}
                                              ></i>
                                              {this.props.checkShippingEasyOrder === true ?
                                                <Text style={[styles.alertInsideTextMobile]}>{i.increment_id} / {moment(i.order_placed_time).format("ll")} / To: {i.firstname} {i.lastname} / PCS: {i.items_count} {i.tracking_num != null ? `/ Tracking Last 6: ${i.tracking_num.slice(-6)}` : ""} / SID: {i.store_order_id}</Text> :
                                                <Text style={[styles.alertInsideTextMobile]}>{moment(i.order_placed_time).format("ll")} / To: {i.firstname} {i.lastname} / PCS: {i.items_count} {i.tracking_num != null ? `/ Tracking Last 6:${i.tracking_num.slice(-6)}` : ""} </Text>}
                                            </LinearGradient>
                                          </ TouchableOpacity>
                                          : <></>
                                      }
                                    </>)
                                }
                              </View>
                            )
                              :
                              <></>
                          }

                          {Order.unscanned_items[0].instruction !== '' &&
                            Order.unscanned_items[0].instruction !== null && (
                              <DisplayInstructions
                               item={Order.unscanned_items[0]}
                               width={901}
                               name={'instructionCheck'}
                              />
                            )}
                          {this.props.isRealTimeStatEnabled && <DisplayDashboardData /> }
                          {/* Scoring Game Component */}
                          <View style={{ 
                            backgroundColor: '#121212', 
                            padding: 10,
                            borderRadius: 4,
                            marginHorizontal: 10,
                            marginVertical: 5
                          }}>
                            {this.props?.scanToScoreEnabled &&<ScoringGame
                              scannedCount={this.calculateScannedCount(this.props.order.order)}
                              onScoreUpdate={(scoreData) => {
                                if (this.state.score !== scoreData.score) {
                                  this.setState({
                                    score: scoreData.score,
                                    multiplier: scoreData.multiplier,
                                    accumulatorProgress: scoreData.accumulatorProgress
                                  });
                                  this.props.updateScanScore({score: scoreData.score});
                                }
                              }}
                              soundsEnabled={true}
                            />}
                          </View>
                          
                          <BoxChampBoxImage
                            boxes={this.props?.Order?.boxes}
                            activeBoxIndex={this.props.activeBoxIndex}
                            activeBoxId={guidedView?.projection?.activeBoxId ?? null}
                            verifiedBoxIds={this.props.verifiedBoxIds}
                            boxChampEnabled={
                              this.props?.bothSettings?.data?.data?.general_setting?.is_box_champ
                            }
                          />
                          <View
                            style={commonStyles.nextItemRowFlexMobile}
                          >
                            <OrderItemSuggested
                             redirectToItemDetail={(item)=>{this.props.redirectToItemDetail(item)}}
                             item={Order.unscanned_items[0]}
                             isSwap={this.props.isSwap}
                             displayRow={!this.props.isSwap &&
                                this.props.rows.map(row => row)}
                             displayRowAtTop = {this.props.isSwap &&
                                this.props.rows.map(row => row)}
                             numberOfKeysEven={this.props.numberOfKeysEven}
                             testID={'redirectToItem'}
                             getFontSize={this.props.getFontSize}
                             addBarcodeFun={(item)=>{this.props.addBarcode(item)}}
                             width={this.props.windowWidth}
                            />
                            <DisplayImage
                              webBigImage={this.props.webBigImage}
                              onError={err => this.props.imageCheck(err)}
                              source={placeholder}
                              defaultSource={placeholder}
                              scanned_qty={Order.unscanned_items[0].scanned_qty}
                              total_qty={
                                Order.unscanned_items[0].qty_remaining +
                                Order.unscanned_items[0].scanned_qty
                              }
                              images={Order.unscanned_items[0].images}
                              updateShowMenu={() =>  {
                                this.setState({ showMenu: true })}}
                            />
                          </View>
                          {this.props.showCameraScanner && (
                            <View style={{ padding: 10 }}>
                              <CamScanner
                                inline={true}
                                bottomControls={true}
                                onScan={this.props.handleCameraScan}
                                onClose={this.props.handleCameraClose}
                              />
                            </View>
                          )}
                        </React.Fragment>
                      )}
                      {!guidedView &&
                        !!this.props?.bothSettings?.data?.data?.general_setting?.is_box_champ &&
                        (this.props.Order || Order)?.order_item_boxes?.length > 0 && (
                        <TouchableOpacity
                          testID="boxchamp-sort-toggle"
                          onPress={this.toggleBoxChampSort}
                          style={{alignSelf: 'center', marginVertical: 6, paddingHorizontal: 12, paddingVertical: 6, backgroundColor: 'rgba(0,0,0,0.35)', borderRadius: 14}}>
                          <Text
                            testID={`boxchamp-sort-mode-${this.state.boxChampSortMode}`}
                            style={{color: '#ffffff', fontSize: 14, fontFamily: fontFamily.font600}}>
                            {this.state.boxChampSortMode === 'packing' ? 'Sort: Packing order' : 'Sort: Location'}
                          </Text>
                        </TouchableOpacity>
                      )}
                      <OrderItemListMenu
                        showScannedList={this.props.showScannedList}
                        showUnScannedList={this.props.showUnscannedList}
                        showLogList={this.props.showLogList}
                        unScannedCount={this.props.unscannedCount}
                        scannedCount={this.props.scannedCount}
                        scannedList={this.props.scannedList}
                        unScannedList={this.props.unscannedList}
                        logList={this.props.logList}
                        navButtonLeft={this.props.navButtonLeft}
                        icon={upArrow}
                        unScannedLabel={getUnscannedItemsTitle(Order.unscanned_items)}
                      />
                           {multi_box_shipments && this.props.order.order.scanned_items.length > 0 &&
                          <View
                            testID='multiBox'
                            style={{
                              display: 'flex',
                              flexDirection: 'initial',
                              justifyContent: 'space-between',
                              marginInline: '10px',
                              padding: '5px',
                            }}
                          >
                            <TouchableOpacity testID='goPrevIcon' onPress={() => { this.props.goPrev() }}>
                              <i className='icon-up-open' style={{
                                color: 'white', transform: 'rotate(270deg)',
                                visibility: this.props.activeBoxIndex <= 0 && 'hidden',
                                fontSize: '21px',
                              }}></i>
                            </TouchableOpacity>
                            <TouchableOpacity
                              onPress={this.props.showUnscannedList}
                            >
                              {this.props.scannedList?
                              <Text style={{ color: 'white', fontSize: '17px' }}>{this.props?.Order?.boxes[this.props.activeBoxIndex]?.name} is Active</Text> :
                              <Text style={{ color: 'white', fontSize: '17px' }}>{this.checky(this.props?.Order?.boxes[this.props.activeBoxIndex]?.id)} of {this.props.scannedCount} Scanned Items in {this.props?.Order?.boxes[this.props.activeBoxIndex]?.name} </Text>}
                            </TouchableOpacity>
                            {this.props.unscannedList &&
                            <TouchableOpacity
                              testID='printSlip'
                              style={{
                                color: "white",
                                position: "absolute",
                                right: 42,
                                marginTop: "1%",
                                marginRight: '3%',
                                width: "5%"
                              }}
                              onPress={() => { this.props.printSlipFun(); }}
                            >
                              <i className='icon-print' style={{ fontSize: 18 }} ></i>
                            </TouchableOpacity>
                            }
                            {this.props?.activeBoxIndex == this.props?.Order?.boxes?.length - 1 &&
                              <TouchableOpacity
                                testID='addBoxIcon'
                                onPress={async () => {
                                  this.addBox();
                                 this.props.popInternet && await this.props.GetOrderDetail({ id: this.props?.order?.order?.id })
                                }}>
                                <i className='icon-plus' style={{
                                  color: 'white',
                                  fontSize: '25px',
                                }}
                                  disable={true}></i>
                              </TouchableOpacity>}
                            {this.props.activeBoxIndex !== this.props.Order?.boxes?.length - 1 && this.props.activeBoxIndex !== this.props.Order?.boxes?.length && <TouchableOpacity testID='goNextIcon' onPress={() => {
                              this.props.goNext()
                            }}>
                              <i className='icon-up-open' style={{
                                color: 'white',
                                fontSize: '25px',
                                transform: 'rotate(90deg)',
                              }}
                              ></i>
                            </TouchableOpacity>}
                          </View>}
                      <ScrollView>
                        {this.props.scannedList && (
                          <React.Fragment>
                            {guidedView ? (
                              <BoxChampZonedList
                                view={guidedView}
                                renderItem={this.renderGuidedCard}
                                onOpenOptions={this.props.openBoxChampOptions}
                              />
                            ) : Order.unscanned_items &&
                              Order.unscanned_items.length > 0 ? (
                              <FlatList
                                data={this.getSortedUnscanned(Order).slice(0, 10)}
                                keyExtractor={item => item.id}
                                extraData={this.state}
                                contentContainerStyle={{paddingBottom: '3rem'}}
                                renderItem={({ item, index }) => (
                                  <View testID={`boxchamp-unscanned-item-${item?.order_item_id}`}>
                                    {(item && item.product_type === 'single') ||
                                      (item &&
                                        item.product_type === 'depends') ? (
                                      item &&
                                        item.qty_remaining == 1 &&
                                        index == 0 ? (
                                        <View></View>
                                      ) : (
                                        <View
                                          key={index}
                                          style={styles.scanPackSingleItemContainer}>
                                          <OrderItem
                                          item={item}
                                          redirectToItemDetail={(item)=>{this.props.redirectToItemDetail(item)}}
                                          testID ={'ProductName'+index}
                                          />
                                          <OrderItemImage
                                          item={item}
                                          testID={'shuffleItem'}
                                          listType={'unscanned'}
                                          shuffleTheItem={(sku)=>{this.props.shuffleTheItem(sku)}}
                                          />

                                        </View>
                                      )
                                    ) : (
                                      <OrderKitItem
                                      item={item}
                                      index={index}
                                      windowWidth={this.props.windowWidth}
                                      redirectToItemDetail={(item)=>{this.props.redirectToItemDetail(item)}}
                                      shuffleTheItem={(sku)=>{this.props.shuffleTheItem(sku)}}
                                      shuffleTheKitItem={(kitSku,itemSku)=>{this.props.shuffleTheItem(kitSku,itemSku)}}
                                      listType={'unscanned'}                                      />
                                    )}
                                  </View>
                                )}
                              />
                            ) : (
                              <View style={globalStyles.p_10}>
                                <Text style={styles.scannedItemNameText}>
                                {i18n.t("nextItems.noItemsToScan")}
                                </Text>
                              </View>
                            )}
                            {!checkIfAllFromNotFulfilled(Order.unscanned_items) && (
                              <View style={{marginBottom: '3rem'}}>
                                <NotFulfilledItems
                                notFullFilledItems={this.props.notFullFilledItems}
                                redirectToItemDetail={(item) => this.props.redirectToItemDetail(item)}
                                shuffleTheItem={(sku) => this.props.shuffleTheItem(sku)}
                              />
                              </View>
                            )}
                          </React.Fragment>
                        )}
                        {this.props.unscannedList && (
                          <React.Fragment>
                             {multi_box_shipments && Order.scanned_items.length > 0 ? <>
                              {this.props?.Order?.order_item_boxes.map((order) => {
                                return (<>
                                  {this.props?.Order?.boxes[this.props.activeBoxIndex]?.id === order.box_id && <>
                                    <View>
                                    {scannedItems
                                        .map((item, index) => {
                                          console.log("item", index,":::", item)
                                          console.log("order:", order.kit_id )
                                          return (
                                            <View>
                                            {(item?.product_id ===
                                              order?.product_id) && order.kit_id === null &&
                                              order.order_item_id === item?.order_item_id &&
                                              (item && item.product_type === 'single') ||
                                              (item && item.product_type === 'depends') ?
                                              (
                                              <ScannedKitItem
                                                item = {item}
                                                order = {order}
                                                activeBoxName = {this.props?.Order?.boxes[this.props.activeBoxIndex]?.name}
                                                redirectToItemDetail={item => {
                                                  this.props.redirectToItemDetail(item);
                                                }}
                                                removeBoxItem = {(box_id, order_item_id, kit_id) =>
                                                  {this.removeBoxItem(box_id, order_item_id, kit_id)
                                                }}
                                              />
                                            ):(
                                              <View>
                                              {(item?.scanned_qty > 0) &&
                                              (item?.product_id === order?.product_id) &&
                                              order.order_item_id === item?.order_item_id
                                              && (
                                                <ScannedKitItemContainer
                                                  item = {item}
                                                  order = {order}
                                                  index = {index}
                                                  lists = {Order}
                                                  activeBoxName = {this.props?.Order?.boxes[this.props.activeBoxIndex]?.name}
                                                  redirectToItemDetail={item => {
                                                    this.props.redirectToItemDetail(item);
                                                  }}
                                                  removeBoxItem = {(box_id, order_item_id, kit_id) =>
                                                    {this.removeBoxItem(box_id, order_item_id, kit_id)
                                                  }}
                                                />
                                              )}
                                              </View>
                                            )}
                                            </View>
                                          );
                                        })}
                                    </View>
                                  </>}
                                </>)
                              })}
                              <View style={{marginTop: '3rem'}}/>
                            </> : <>
                            {Order.scanned_items &&
                              Order.scanned_items.length > 0 ? (
                              <FlatList
                                data={scannedItems.slice(0, 10)}
                                keyExtractor={item => item.id}
                                extraData={this.state}
                                contentContainerStyle={{paddingBottom: '3rem'}}
                                renderItem={({ item, index }) => (
                                  <View style={{ textAlign: 'left' }}>
                                    {item.scanned_qty > 0 &&
                                    item?.product_type != "individual" &&
                                    (item?.child_items?.length === 0 || item?.child_items === undefined) && (
                                      <View
                                        testID='ScannedItems'
                                        key={index}
                                        style={styles.scanPackSingleItemContainer}
                                      >
                                        <OrderItem
                                         item={item}
                                         testID={'redirectToItemDetail'}
                                         redirectToItemDetail={(item)=>{this.props.redirectToItemDetail(item)}}
                                        />
                                        <OrderItemImage
                                         item={item}
                                         listType={'scanned'}
                                         shuffleTheItem={()=>{}}
                                        />
                                      </View>
                                    )}
                                  </View>
                                )}
                              />
                            ) : (
                              <View style={globalStyles.p_10}></View>
                            )}
 </>}

                          </React.Fragment>
                        )}
                        {this.props.logList && (
                          <React.Fragment>
                            {localLogs && localLogs.length > 0 ? (
                              <DisplayLogs
                              logs={localLogs}
                              sliceNum={10}
                              checkMultiBoxActive={this.props?.checkMultiBoxActive}
                             />
                            ) : (
                              <View style={globalStyles.p_10}></View>
                            )}
                          </React.Fragment>
                        )}
                      </ScrollView>
                    </View>
                  </View>
                )}
              </View>
            </ScrollView>
          </View>
        ) : (
          <View
            testID='NoOrderPresent'
            style={globalStyles.noOrderPresent}
          >
            <Text style={{ fontSize: 14, fontWeight: 'bold', color: '#fff' }}>
            {i18n.t("nextItems.noOrderToScan")}
            </Text>
          </View>
        )}
      </>
    );
  }
}
const mapDispatchToProps = {
  AddBox,
  GetOrderDetail,
  PrintSlip,
  RemoveBoxItems,
  updateScanScore
}
const mapStateToProps = state => {
  return {
    isSwap: state.menu.isSwap,
    isHaptics: state.menu.isHaptics,
    removeOrderItems: state.order.removeOrderItems,
    scanToScoreEnabled: state.user?.settings?.data?.scan_to_score
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(NextItemMobileView);
